import { createContext, useContext, useState } from 'react';
import { AssociateFeedback } from '../types/feedbacks';

// declaring the context datatypes here
interface IAssociateFeedbackContext {
  associateFeedback: AssociateFeedback | null;
  showAssociateFeedbackModal: boolean;
  setShowAssociateFeedbackModal: React.Dispatch<React.SetStateAction<boolean>>;
  setAssociateFeedback: React.Dispatch<
    React.SetStateAction<AssociateFeedback | null>
  >;
}

// creating the context here
const AssociateFeedbackContext =
  createContext<IAssociateFeedbackContext | null>(null);

const AssociateFeedbackProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // integration of react hooks here
  const [showAssociateFeedbackModal, setShowAssociateFeedbackModal] =
    useState<boolean>(false);

  const [associateFeedback, setAssociateFeedback] =
    useState<AssociateFeedback | null>(null);

  // rendering the context provider here
  return (
    <AssociateFeedbackContext.Provider
      value={{
        associateFeedback,
        showAssociateFeedbackModal,
        setShowAssociateFeedbackModal,
        setAssociateFeedback,
      }}
    >
      {children}
    </AssociateFeedbackContext.Provider>
  );
};

export default AssociateFeedbackProvider;

// creating custom hook to access the associate feedback context here
export const useAssociateFeedbackContext = () => {
  const context = useContext(AssociateFeedbackContext);

  if (!context) {
    throw new Error(
      'useAssociateFeedbackContext must be within AssociateFeedbackProvider!'
    );
  }

  return context;
};
